/**
 * @desc 获取树形结构(新增)
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/organization/getTree`, {
      method: "GET",

      ...options,
    }),
  );
}
